window.dataLayer = window.dataLayer || [];

window.dataLayer.push({
    'pageType': ShopifyAnalytics.meta.pageType || null, // Home Page / PLP / PDP / Checkout / Payment
    'pageCategory': ShopifyAnalytics.meta.pageCategory || null, // Makeup / Accessories / Fragrances
    'storeLanguage': ShopifyAnalytics.meta.language || null, // en / ar
    'storeCurrency': ShopifyAnalytics.meta.currency || null, // AED
    'storeCountry': ShopifyAnalytics.meta.country || null, // UAE
    'userId': ShopifyAnalytics.meta.userId || null, // Unique user ID
    'userType': ShopifyAnalytics.meta.userType || null, // Anonymous / Registered user
    'loggedInStatus': ShopifyAnalytics.meta.loggedInStatus || null, // Yes / No
    'hashedEmail': ShopifyAnalytics.meta.hashedEmail || null, // SHA256 hashed email of user
    'userEmail': ShopifyAnalytics.meta.userEmail || null // Email ID of user
});

// // Measuring Promotion Impression
// window.dataLayer.push({
//     event: "view_promotion",
//     ecommerce: {
//         currency: ShopifyAnalytics.meta.currency || 'AED',
//         items: (ShopifyAnalytics.meta.promotions || []).map(promotion => ({
//             promotion_id: promotion.id || null,
//             promotion_name: promotion.name || null,
//             creative_name: promotion.creative || null,
//             creative_slot: promotion.slot || null,
//             location_id: promotion.location || null
//         }))
//     }
// });

// // Login Event
// if (ShopifyAnalytics.meta.loginMethod) {
//     window.dataLayer.push({
//         event: 'login',
//         method: ShopifyAnalytics.meta.loginMethod.toLowerCase()
//     });
// }

// // Sign-Up Event
// if (ShopifyAnalytics.meta.signUpMethod) {
//     window.dataLayer.push({
//         event: 'sign_up',
//         method: ShopifyAnalytics.meta.signUpMethod.toLowerCase()
//     });
// }

// // Newsletter Subscribe Event
// if (ShopifyAnalytics.meta.hashedEmail) {
//     window.dataLayer.push({
//         event: 'newsletter_subscribe',
//         hashed_email: ShopifyAnalytics.meta.hashedEmail
//     });
// }

// Page View Event
window.dataLayer.push({
    event: 'page_view',
    pageType: window.shopifyData.pageType || 'unknown',
    pageCategory: window.shopifyData.pageCategory || 'unknown',
    storeLanguage: window.shopifyData.storeLanguage || 'en',
    storeCurrency: window.shopifyData.storeCurrency || 'AED',
    storeCountry: window.shopifyData.storeCountry || 'UAE',
    userId: window.shopifyData.userId || 'unknown',
    userType: window.shopifyData.userType || 'anonymous',
    loggedInStatus: window.shopifyData.loggedInStatus || 'no',
    firstName: window.shopifyData.firstName,
    lastName: window.shopifyData.lastName,
    hashedEmail: window.shopifyData.hashedEmail || '',
    userEmail: window.shopifyData.userEmail || ''
});

// // Product Impression Event
// if (ShopifyAnalytics.meta.productImpressions) {
//     window.dataLayer.push({
//         event: 'view_item_list',
//         ecommerce: {
//             currency: ShopifyAnalytics.meta.currency || 'AED',
//             value: ShopifyAnalytics.meta.impressionValue || 0,
//             item_list_id: ShopifyAnalytics.meta.itemListId || 'unknown',
//             item_list_name: ShopifyAnalytics.meta.itemListName || 'unknown',
//             items: ShopifyAnalytics.meta.productImpressions.map(product => ({
//                 item_id: product.sku || null,
//                 item_name: product.name || null,
//                 item_brand: product.brand || null,
//                 item_category: product.category || null,
//                 item_variant: product.variant || null,
//                 price: product.price || 0,
//                 quantity: product.quantity || 1,
//                 discount: product.discount || 0,
//                 discount_percentage: product.discount_percentage || null,
//                 sale_status: product.sale_status || ""
//             }))
//         }
//     });
// }

// // Add to Cart Event
// if (ShopifyAnalytics.meta.addToCartItems) {
//     window.dataLayer.push({
//         event: 'add_to_cart',
//         ecommerce: {
//             currency: ShopifyAnalytics.meta.currency || 'AED',
//             value: ShopifyAnalytics.meta.cartValue || 0,
//             items: ShopifyAnalytics.meta.addToCartItems.map(item => ({
//                 item_id: item.sku || null,
//                 item_name: item.name || null,
//                 item_brand: item.brand || null,
//                 item_category: item.category || null,
//                 item_variant: item.variant || null,
//                 price: item.price || 0,
//                 quantity: item.quantity || 1,
//                 discount: item.discount || 0,
//                 discount_percentage: item.discount_percentage || null,
//                 sale_status: item.sale_status || ""
//             }))
//         }
//     });
// }

// // Remove from Cart Event
// if (ShopifyAnalytics.meta.removeFromCartItems) {
//     window.dataLayer.push({
//         event: 'remove_from_cart',
//         ecommerce: {
//             currency: ShopifyAnalytics.meta.currency || 'AED',
//             value: ShopifyAnalytics.meta.cartValue || 0,
//             items: ShopifyAnalytics.meta.removeFromCartItems.map(item => ({
//                 item_id: item.sku || null,
//                 item_name: item.name || null,
//                 item_brand: item.brand || null,
//                 item_category: item.category || null,
//                 item_variant: item.variant || null,
//                 price: item.price || 0,
//                 quantity: item.quantity || 1,
//                 discount: item.discount || 0,
//                 discount_percentage: item.discount_percentage || null,
//                 sale_status: item.sale_status || ""
//             }))
//         }
//     });
// }

// // View Cart Event
// if (ShopifyAnalytics.meta.cartItems) {
//     window.dataLayer.push({
//         event: 'view_cart',
//         ecommerce: {
//             currency: ShopifyAnalytics.meta.currency || 'AED',
//             value: ShopifyAnalytics.meta.cartValue || 0,
//             items: ShopifyAnalytics.meta.cartItems.map(item => ({
//                 item_id: item.sku || null,
//                 item_name: item.name || null,
//                 item_brand: item.brand || null,
//                 item_category: item.category || null,
//                 item_variant: item.variant || null,
//                 price: item.price || 0,
//                 quantity: item.quantity || 1,
//                 discount: item.discount || 0,
//                 discount_percentage: item.discount_percentage || null,
//                 sale_status: item.sale_status || ""
//             }))
//         }
//     });
// }

// // Begin Checkout Event
// if (ShopifyAnalytics.meta.checkoutItems) {
//     window.dataLayer.push({
//         event: 'begin_checkout',
//         ecommerce: {
//             currency: ShopifyAnalytics.meta.currency || 'AED',
//             value: ShopifyAnalytics.meta.checkoutValue || 0,
//             items: ShopifyAnalytics.meta.checkoutItems.map(item => ({
//                 item_id: item.sku || null,
//                 item_name: item.name || null,
//                 item_brand: item.brand || null,
//                 item_category: item.category || null,
//                 item_variant: item.variant || null,
//                 price: item.price || 0,
//                 quantity: item.quantity || 1,
//                 discount: item.discount || 0,
//                 discount_percentage: item.discount_percentage || null,
//                 sale_status: item.sale_status || ""
//             }))
//         }
//     });
// }

// // Purchase Event
// if (ShopifyAnalytics.meta.purchaseItems) {
//     window.dataLayer.push({
//         event: 'purchase',
//         ecommerce: {
//             transaction_id: ShopifyAnalytics.meta.transactionId || 'T_12345',
//             currency: ShopifyAnalytics.meta.currency || 'AED',
//             value: ShopifyAnalytics.meta.purchaseValue || 0,
//             tax: ShopifyAnalytics.meta.tax || 0,
//             shipping: ShopifyAnalytics.meta.shipping || 0,
//             coupon: ShopifyAnalytics.meta.coupon || '',
//             items: ShopifyAnalytics.meta.purchaseItems.map(item => ({
//                 item_id: item.sku || null,
//                 item_name: item.name || null,
//                 item_brand: item.brand || null,
//                 item_category: item.category || null,
//                 item_variant: item.variant || null,
//                 price: item.price || 0,
//                 quantity: item.quantity || 1,
//                 discount: item.discount || 0,
//                 discount_percentage: item.discount_percentage || null,
//                 sale_status: item.sale_status || ""
//             }))
//         }
//     });
// }

// // Select Promotion Event
// if (ShopifyAnalytics.meta.selectedPromotion) {
//     window.dataLayer.push({
//         event: 'select_promotion',
//         ecommerce: {
//             promotion_id: ShopifyAnalytics.meta.selectedPromotion.id || null,
//             promotion_name: ShopifyAnalytics.meta.selectedPromotion.name || null
//         }
//     });
// }

// // Collection View Event
// if (ShopifyAnalytics.meta.collectionView) {
//     window.dataLayer.push({
//         event: 'collection_view',
//         ecommerce: {
//             item_list_id: ShopifyAnalytics.meta.collectionView.id || null,
//             item_list_name: ShopifyAnalytics.meta.collectionView.name || null
//         }
//     });
// }

// // Select Item Event
// if (ShopifyAnalytics.meta.selectedItem) {
//     window.dataLayer.push({
//         event: 'select_item',
//         ecommerce: {
//             items: [
//                 {
//                     item_id: ShopifyAnalytics.meta.selectedItem.sku || null,
//                     item_name: ShopifyAnalytics.meta.selectedItem.name || null,
//                     item_brand: ShopifyAnalytics.meta.selectedItem.brand || null,
//                     item_category: ShopifyAnalytics.meta.selectedItem.category || null,
//                     item_variant: ShopifyAnalytics.meta.selectedItem.variant || null,
//                     price: ShopifyAnalytics.meta.selectedItem.price || 0,
//                     discount: ShopifyAnalytics.meta.selectedItem.discount || 0,
//                     discount_percentage: ShopifyAnalytics.meta.selectedItem.discount_percentage || null,
//                     sale_status: ShopifyAnalytics.meta.selectedItem.sale_status || ""
//                 }
//             ]
//         }
//     });
// }

// // View Item Event
// if (ShopifyAnalytics.meta.viewedItem) {
//     window.dataLayer.push({
//         event: 'view_item',
//         ecommerce: {
//             items: [
//                 {
//                     item_id: ShopifyAnalytics.meta.viewedItem.sku || null,
//                     item_name: ShopifyAnalytics.meta.viewedItem.name || null,
//                     item_brand: ShopifyAnalytics.meta.viewedItem.brand || null,
//                     item_category: ShopifyAnalytics.meta.viewedItem.category || null,
//                     item_variant: ShopifyAnalytics.meta.viewedItem.variant || null,
//                     price: ShopifyAnalytics.meta.viewedItem.price || 0,
//                     discount: ShopifyAnalytics.meta.viewedItem.discount || 0,
//                     discount_percentage: ShopifyAnalytics.meta.viewedItem.discount_percentage || null,
//                     sale_status: ShopifyAnalytics.meta.viewedItem.sale_status || ""
//                 }
//             ]
//         }
//     });
// }

// // Add Payment Info Event
// if (ShopifyAnalytics.meta.paymentInfo) {
//     window.dataLayer.push({
//         event: 'add_payment_info',
//         ecommerce: {
//             currency: ShopifyAnalytics.meta.currency || 'AED',
//             payment_type: ShopifyAnalytics.meta.paymentInfo.type || 'unknown',
//             value: ShopifyAnalytics.meta.paymentInfo.value || 0,
//             items: ShopifyAnalytics.meta.paymentInfo.items ? ShopifyAnalytics.meta.paymentInfo.items.map(item => ({
//                 item_id: item.sku || null,
//                 item_name: item.name || null,
//                 item_brand: item.brand || null,
//                 item_category: item.category || null,
//                 item_variant: item.variant || null,
//                 price: item.price || 0,
//                 quantity: item.quantity || 1,
//                 discount: item.discount || 0,
//                 discount_percentage: item.discount_percentage || null,
//                 sale_status: item.sale_status || ""
//             })) : []
//         }
//     });
// }
